import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';

type GeoEventRegionsSelectorProps = {
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  label?: string;
  onChange: (regionIds: number[]) => void;
  regions: GeoEventRegion[];
  required?: boolean;
  selectedRegionIds: number[];
};

export const GeoEventRegionsSelector = (
  props: GeoEventRegionsSelectorProps,
): JSX.Element => {
  const {
    disabled = false,
    error = false,
    helperText,
    label,
    onChange,
    regions,
    required = true,
    selectedRegionIds,
  } = props;
  const { t } = useTranslation();

  const handleToggle = (regionId: number) => (): void => {
    onChange(
      selectedRegionIds.includes(regionId)
        ? selectedRegionIds.filter((id) => id !== regionId)
        : [...selectedRegionIds, regionId],
    );
  };

  return (
    <FormControl
      component="fieldset"
      disabled={disabled}
      error={error}
      fullWidth
      required={required}
    >
      <FormLabel component="legend">
        {label ?? t('editGeoEvent.inputs.criticalAlertCounties.label')}
      </FormLabel>
      <FormGroup sx={{ flexDirection: 'row', flexWrap: 'wrap', columnGap: 2 }}>
        {regions.map((region) => (
          <FormControlLabel
            key={region.id}
            control={
              <Checkbox
                checked={selectedRegionIds.includes(region.id)}
                onChange={handleToggle(region.id)}
              />
            }
            label={`${region.displayName}, ${region.state}`}
          />
        ))}
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
